import React, { useEffect, useRef, useState } from "react";
import { HiXMark } from "react-icons/hi2";
import { cn } from "../../../../helpers/utils/css-utils";

const DrawerPanel = React.forwardRef(({ children, open, onClose }, ref) => {
  const timeoutRef = useRef(null);
  const [isOpen, setIsOpen] = useState(open);
  const [shouldRender, setShouldRender] = useState(open);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsOpen(true);
      }, 150);
    } else {
      setIsOpen(false);
      timeoutRef.current = setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open]);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  // Close on Escape, which users expect from a modal side panel.
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape" && onClose) onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-50 h-full w-full overflow-hidden bg-transparent"
      onClick={onClose}
    >
      {/* panel */}
      <div
        ref={ref}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        className={cn(
          `fixed bottom-0 top-0 z-[999] flex w-full max-w-md flex-col border-l border-gray-200 bg-white
           shadow-2xl shadow-black/20 transition-transform duration-300 ease-out
`,
          {
            "right-0 translate-x-0": isOpen,
            "right-0 translate-x-full": !isOpen,
          }
        )}
      >
        {/* close affordance floats over the settings header */}
        <button
          onClick={onClose}
          aria-label="Close panel"
          className="absolute right-3 top-3 z-20 inline-flex h-8 w-8 items-center justify-center rounded-lg
            text-gray-400 transition-colors duration-200 hover:bg-gray-100 hover:text-gray-900
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <HiXMark className="h-5 w-5" />
        </button>

        <div className="flex flex-1 flex-col overflow-hidden">{children}</div>
      </div>

      {/* overlay */}
      <div
        className={cn(
          "fixed inset-0 z-[998] h-screen w-screen bg-gray-900/30 backdrop-blur-[2px] transition-opacity duration-300 ease-out dark:bg-black/50",
          {
            "opacity-100": isOpen,
            "opacity-0": !isOpen,
          }
        )}
      />
    </div>
  );
});

export { DrawerPanel };
